import axios from 'axios';

export const api = () => {
  return axios.create({
    baseURL: '/api',
    headers: {
      "Content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('token')}`,
    },
  });
}
